import { Box, Typography } from "@mui/material";
import { toToman } from "../../utils/Utils";
import {
  WalletTransactionSide,
  WalletTransactionStatus,
  WalletTransactionStatusFarsi,
  WalletTransactionType,
  WalletTransactionTypeFarsi,
} from "../../types/WalletTransactionType";
import { ReactComponent as DebitBox } from "../../assets/icons/debit-box.svg";
import { ReactComponent as CreditBox } from "../../assets/icons/credit-box.svg";
import { useTheme } from "@emotion/react";
import moment from "moment-jalaali";

const Item = ({ title, value }) => {
  return (
    <Box
      sx={{
        mt: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Typography variant="subtitle1" color="grey.4">
        {title}
      </Typography>
      <Typography variant="h6" color="grey.2">
        {value}
      </Typography>
    </Box>
  );
};

function WalletTransactionCard({ sx = [], ...props }) {
  const { walletTransaction, first } = props;
  const theme = useTheme();

  const getWalletTransactionColor = (status) => {
    switch (status) {
      case WalletTransactionStatus.INITIATED:
      case WalletTransactionStatus.PENDING:
        return theme.palette.orange.main;
      case WalletTransactionStatus.DONE:
        return theme.palette.primary.main;
      case WalletTransactionStatus.CANCEL:
        return theme.palette.red.main;
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        py: "16px",
        display: "flex",
        borderTop: (theme) =>
          first ? null : `1px solid ${theme.palette.grey[6]}`,
      }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        {walletTransaction.side === WalletTransactionSide.DEBIT ? (
          <>
            <DebitBox width={24} height={24} />
            <Typography variant="subtitle1" color="grey.3">
              برداشت
            </Typography>
          </>
        ) : (
          <>
            <CreditBox width={24} height={24} />
            <Typography variant="subtitle1" color="grey.3">
              واریز
            </Typography>
          </>
        )}
      </Box>
      <Box
        sx={{ ml: "24px", flex: 1, display: "flex", flexDirection: "column" }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h5" color="grey.2">
            {WalletTransactionTypeFarsi[walletTransaction.type]}
          </Typography>
          <Typography
            variant="h5"
            color={getWalletTransactionColor(walletTransaction.status)}
          >
            {WalletTransactionStatusFarsi[walletTransaction.status]}
          </Typography>
        </Box>
        <Item
          title={"زمان"}
          value={moment(walletTransaction.date).format("HH:mm jYYYY/jMM/jDD")}
        />
        {walletTransaction.type === WalletTransactionType.CASHOUT &&
          walletTransaction.walletTraceCode && (
            <Item
              title={"کد پیگیری"}
              value={walletTransaction.walletTraceCode}
            />
          )}
        <Item
          title={
            <>
              مبلغ{" "}
              <Typography display={"inline"} fontSize={"10px"}>
                (تومان)
              </Typography>{" "}
            </>
          }
          value={toToman(walletTransaction.amount)}
        />
        {walletTransaction.balance !== undefined && (
          <Item
            title={
              <>
                موجودی قلک{" "}
                <Typography display={"inline"} fontSize={"10px"}>
                  (تومان)
                </Typography>{" "}
              </>
            }
            value={toToman(walletTransaction.balance)}
          />
        )}
      </Box>
    </Box>
  );
}

export default WalletTransactionCard;
